import { GenIcon } from '../helpers/IconBase.es.js';

const ListLocationOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19.0002 9V5C19.0002 4.46957 18.7895 3.96086 18.4144 3.58579C18.0394 3.21071 17.5307 3 17.0002 3H4.99023C3.88023 3 2.99023 3.89 2.99023 5V19C2.99023 20.1 3.88023 20.99 4.99023 20.99H8.98023",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9 11H10.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9 7H15",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.00022 15.1251H5.99022C6.05022 15.1251 6.11022 15.0651 6.11022 14.9951C6.11022 14.9251 6.05022 14.8651 5.98022 14.8651C5.91022 14.8551 5.85022 14.9151 5.85022 14.9851V14.9751C5.84022 15.0351 5.90022 15.0951 5.97022 15.0951",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9 15H9.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.00022 11.1251H5.99022C6.05022 11.1251 6.11022 11.0651 6.11022 10.9951C6.11022 10.9251 6.05022 10.8651 5.98022 10.8651C5.91022 10.8551 5.85022 10.9151 5.85022 10.9851V10.9751C5.84022 11.0351 5.90022 11.0951 5.97022 11.0951",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.00022 7.11998H5.99022C6.05022 7.11998 6.11022 7.05998 6.11022 6.98998C6.11022 6.91998 6.05022 6.85998 5.98022 6.85998C5.91022 6.84998 5.85022 6.90998 5.85022 6.97998V6.96998C5.84022 7.02998 5.90022 7.08998 5.97022 7.08998",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.0547 14.8799V19.4899C13.0547 20.3099 13.7247 20.9799 14.5547 20.9799H19.5547H19.5447C20.3647 20.9799 21.0447 20.2999 21.0447 19.4799V14.9299",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M22.01 15.7099L17.63 12.1999C17.26 11.8999 16.74 11.8999 16.38 12.1899L12 15.6899",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { ListLocationOutlined };
